/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Is the file a file or a directory.
 */
export const FileType = /* #__PURE__ */ parsers.exactly('file', 'directory');
